<df-tactic-preview
  [tactic]="tactic"
  [inModal]="true"
  [context]="context"
></df-tactic-preview>
